/**
 * SlugLandingV2 — v2 reskin of public/SlugLanding (UI-v2 Phase 1e).
 *
 * Logic verbatim from v1 (localStorage LAST_SLUG_KEY redirect, form submit).
 * Presentation: AuthShellV2 + shadcn Input + FormFieldV2.
 *
 * Note: on slug submit, navigates to /{slug}/login — the tenant login route,
 * which serves LoginV2 as of PR4 ("the flip"). Not `useTenantBase()`: this page
 * is slug-LESS (it is what the user hits when we don't know their tenant yet),
 * so there is no :tenantSlug param to read — the slug comes from localStorage or
 * the form itself. Same reason its sibling VerifyEmailV2 builds its path by hand.
 */
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { FormFieldV2 } from "@/components/v2/patterns/FormV2";
import { AuthShellV2 } from "@/components/v2/layout/AuthShellV2";
import { LAST_SLUG_KEY } from "@/stores/useAuthStore";

export default function SlugLandingV2(): JSX.Element {
  const [slug, setSlug] = useState("");

  useEffect(() => {
    const saved = window.localStorage.getItem(LAST_SLUG_KEY);
    if (saved) {
      window.location.replace(`/${saved}/login`);
    }
  }, []);

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (slug.trim()) {
      window.location.assign(`/${slug.trim()}/login`);
    }
  };

  return (
    <AuthShellV2
      title="Sign in to CertAIn"
      subtitle="Enter your workspace URL to continue."
      footer={
        <>
          New to CertAIn?{" "}
          <Link
            to="/auth/v2/signup"
            className="font-medium text-text-link hover:text-text-link-hover"
          >
            Start a free trial
          </Link>
        </>
      }
    >
      <form onSubmit={handleSubmit} className="flex flex-col gap-4">
        <FormFieldV2 label="Workspace URL" htmlFor="slug-v2">
          <div className="flex items-stretch">
            <span
              className="inline-flex items-center rounded-l-[var(--radius,0.5rem)] border border-r-0 border-border-strong bg-surface-subtle text-text-tertiary"
              style={{ padding: "0 12px", fontSize: "13.5px" }}
            >
              certainhr.ai/
            </span>
            <Input
              id="slug-v2"
              type="text"
              placeholder="your-company"
              value={slug}
              onChange={(e) => setSlug(e.target.value)}
              required
              className="rounded-l-none"
            />
          </div>
        </FormFieldV2>
        <Button type="submit" className="w-full">
          Continue
        </Button>
      </form>
    </AuthShellV2>
  );
}
